module.exports = __webpack_public_path__ + "img/1-210P6115AD20.f147db96.png";